// Copyright (c) StrangeBee 2023

export const tactics: Record<string, { label: string; color: string }> = {
    reconnaissance: {
        label: 'Reconnaissance',
        color: '#D1BBD7',
    },
    'resource-development': {
        label: 'Resource Development',
        color: '#AE76A3',
    },
    'initial-access': {
        label: 'Initial Access',
        color: '#882E72',
    },
    execution: {
        label: 'Execution',
        color: '#1965B0',
    },
    persistence: {
        label: 'Persistence',
        color: '#5289C7',
    },
    'privilege-escalation': {
        label: 'Privilege Escalation',
        color: '#7BAFDE',
    },
    'defense-evasion': {
        label: 'Defense Evasion',
        color: '#4EB256',
    },
    'credential-access': {
        label: 'Credential Access',
        color: '#90C987',
    },
    discovery: {
        label: 'Discovery',
        color: '#CAE0AB',
    },
    'lateral-movement': {
        label: 'Lateral Movement',
        color: '#F7F056',
    },
    collection: {
        label: 'Collection',
        color: '#F6C141',
    },
    'command-and-control': {
        label: 'Command and Control',
        color: '#F1932D',
    },
    exfiltration: {
        label: 'Exfiltration',
        color: '#E8601C',
    },
    impact: {
        label: 'Impact',
        color: '#DC050C',
    },
};
